import axios from "axios";
import Cookies from "js-cookie";

// Simple shared counter to avoid flicker when multiple API calls are in-flight
let activeRequests = 0;

const showGlobalLoader = () => {
  activeRequests += 1;
  document.body.classList.add("loading-indicator");
};

const hideGlobalLoader = () => {
  activeRequests = Math.max(0, activeRequests - 1);
  if (activeRequests === 0) {
    document.body.classList.remove("loading-indicator");
  }
};

const checkAuth = () => {
  /*  Getting token value stored in localstorage, if token is not present we will open login page 
    for all internal dashboard routes  */
  const TOKEN = localStorage.getItem("token");
  const PUBLIC_ROUTES = [
    "login",
    "forgot-password",
    "register",
    "documentation",
  ];

  const isPublicPage = PUBLIC_ROUTES.some((r) =>
    window.location.href.includes(r)
  );
  const isAuthenticated = !!Cookies.get("auth");

  // if (!TOKEN && !isPublicPage && !isAuthenticated) {
  if (!isPublicPage && !isAuthenticated) {
    window.location.href = "/login";
    return;
  } else {
    axios.defaults.headers.common["Authorization"] = `Bearer ${TOKEN}`;

    axios.interceptors.request.use(
      function (config) {
        showGlobalLoader();
        return config;
      },
      function (error) {
        hideGlobalLoader();
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        hideGlobalLoader();
        if (response.status === 401) {
          window.location.href = "/login";
        }
        return response;
      },
      function (error) {
        hideGlobalLoader();
        return Promise.reject(error);
      }
    );
    return TOKEN;
  }
};

export default checkAuth;
